/* eslint-disable */
// @ts-nocheck
/**
 * RTM Frontend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */

export const VolumeComparisonType = {
  Forecasts: 'FORECASTS',
  FourWeekAverage: 'FOUR_WEEK_AVERAGE',
  LastWeek: 'LAST_WEEK',
  Outflow: 'OUTFLOW',
} as const

export type VolumeComparisonType =
  (typeof VolumeComparisonType)[keyof typeof VolumeComparisonType]
